import { render, staticRenderFns } from "./PreWizard.vue?vue&type=template&id=316d95a4&"
import script from "./PreWizard.vue?vue&type=script&lang=js&"
export * from "./PreWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports